<script setup lang="ts">
import { ref } from 'vue';
import { useRoute } from 'vue-router';
import AppHeader from './AppHeader.vue';
import ModalLogin from '../organisms/modal/ModalLogin.vue';
import ModalRelogin from '../organisms/modal/ModalRelogin.vue';
import { PAGE_CUSTOM_FIELDS, PAGE_FORM, PAGE_PREVIEW, PAGE_SUCCESS } from '../../routes';
import { track } from '../../utils/tracking';
import { useRelogin } from '../../composables/relogin';
import ModalExtractCv from '../organisms/modal/ModalExtractCv.vue';

const { showReloginModal, reloginUrl } = useRelogin();
const route = useRoute();

const showLoginModal = ref(false);
const showExtractCvModal = ref(false);

function getRouteName(routeName) {
    switch (routeName) {
    case PAGE_FORM: return 'Form';
    case PAGE_CUSTOM_FIELDS: return 'Custom Fields';
    case PAGE_PREVIEW: return 'Preview';
    case PAGE_SUCCESS: return 'Successpage';
    default: return '';
    }
}

function openLoginModal() {
    track({
        element: 'AP_F: Header Login Button',
        elementDetail: getRouteName(route.name),
    });
    showLoginModal.value = true;
}

defineExpose({ showExtractCvModal });
</script>

<template>
    <div
        id="main"
        class="c-layoutMinimalContent"
    >
        <ModalLogin v-model:open="showLoginModal"/>
        <ModalRelogin
            v-model:open="showReloginModal"
            :button-url="reloginUrl"
        />
        <ModalExtractCv
            v-model:open="showExtractCvModal"
        />
        <AppHeader
            data-qa="header"
            @open-login-modal="openLoginModal"
        />
        <main class="c-layoutMinimalContent__main">
            <slot name="main"/>
        </main>
        <slot name="footer"/>
    </div>
</template>

<style lang="scss">
.c-layoutMinimalContent {
    display: flex;
    flex-direction: column;
    min-height: 100vh;

    &__main {
        flex-grow: 1;
    }
}
</style>
